import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Experience from "../components/Experience";
import Education from "../components/Education";
import About from "../components/About";
import Projects from "../components/Projects";
import Skills from "../components/Skills";
import ExtraBits from "../components/ExtraBits";
import References from "../components/References";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const Portfolio = () => {
	return (
		<div className="min-h-screen bg-[#04100f] text-slate-100 selection:bg-teal-500/30">
			<Header />
			<main>
				<Hero />
				<About />
				<Experience />
				<Education />

				<Projects />
				<Skills />
				<ExtraBits />
				<References />
				<Contact />
			</main>
			<Footer />
		</div>
	);
};

export default Portfolio;
